// ShaharinDoc.jsx
import React from 'react'
import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import shaharinDoc from '../../../../assets/images/Doctorsimages/Shaharindr.png' // Assuming standard naming convention
import favicon from "../../../../assets/images/favicon.ico"
import AutoScrollImageRow from '../../AdvancedTreatmentsforHome/AutoScrollImageRow'
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';

const ShaharinDoc = () => {
  const navigate = useNavigate(); 
   useEffect(() => {
       document.title = "Dr. Shaharin Banu | Homoeopathic Consultant & Dietician | Compassionate Patient Care";
       const metaDescription = document.querySelector("meta[name='description']");
       if (metaDescription) {
         metaDescription.setAttribute(
           "content",
           "Consult Dr. Shaharin Banu (BHMS), a dedicated Homoeopathic Consultant and Dietician. Specializing in patient-centered care, holistic wellness, and integrity-driven treatments. Book your consultation for natural healing today."
         );
       }
       const metaKeywords = document.querySelector("meta[name='keywords']");
     if (metaKeywords) {
  metaKeywords.setAttribute(
    "content",
    "best homeopathy doctor, homoeopathic consultant near me, female homeopathy doctor, qualified dietician and homeopath, holistic health consultant, homeopathic medical consultant, patient-centered homeopathic care, diet and nutrition consultant, homeopathy for wellness, BHMS doctor near me"
  );
}

        // Set canonical link
        const existingCanonical = document.querySelector("link[rel='canonical']");
        if (existingCanonical) {
          existingCanonical.setAttribute("href", "https://www.h-cura.com/doctors/dr-shaharin-banu-homeopathy-consultant-puducherry");
        } else {
          const canonicalLink = document.createElement("link");
          canonicalLink.setAttribute("rel", "canonical");
          canonicalLink.setAttribute("href", "https://www.h-cura.com/doctors/dr-shaharin-banu-homeopathy-consultant-puducherry");
          document.head.appendChild(canonicalLink);
        }
        // Set favicon
     const existingFavicon = document.querySelector("link[rel='icon']");
     if (existingFavicon) {
       existingFavicon.setAttribute("href", favicon);
     } else {
       const faviconLink = document.createElement("link");
       faviconLink.setAttribute("rel", "icon");
       faviconLink.setAttribute("type", "image/x-icon");
       faviconLink.setAttribute("href", favicon);
       document.head.appendChild(faviconLink);
     }
     }, []);

const handleDownloadPdf = () => {
  const container = document.querySelector('.veenadoc');
  container.classList.add('veenadoc-pdf-mode');
  const originalStyles = new Map();
  const allElements = container.querySelectorAll('*');
  
  allElements.forEach(el => {
    originalStyles.set(el, {
      transition: el.style.transition,
      animation: el.style.animation,
      transform: el.style.transform,
      filter: el.style.filter
    });
    el.style.transition = 'none';
    el.style.animation = 'none';
    el.style.transform = 'none';
    el.style.filter = 'none';
  });

  const heroSection = container.querySelector('.veenadoc-hero-section');
  if (heroSection) {
    heroSection.style.minHeight = 'auto';
    heroSection.style.padding = '40px 0';
  }

  const images = container.querySelectorAll('img');
  images.forEach(img => {
    img.style.opacity = '1';
  });

  setTimeout(() => {
    html2canvas(container, {
      scale: 2,
      dpi: 300,
      useCORS: true,
      allowTaint: true,
      letterRendering: true,
      backgroundColor: '#ffffff',
      logging: false,
      windowWidth: container.scrollWidth,
      windowHeight: container.scrollHeight,
      scrollY: -window.scrollY,
      scrollX: -window.scrollX,
      imageTimeout: 0,
      removeContainer: false
    }).then(canvas => {
      container.classList.remove('veenadoc-pdf-mode');
      allElements.forEach(el => {
        const original = originalStyles.get(el);
        el.style.transition = original.transition;
        el.style.animation = original.animation;
        el.style.transform = original.transform;
        el.style.filter = original.filter;
      });

      if (heroSection) {
        heroSection.style.minHeight = '';
        heroSection.style.padding = '';
      }

      const imgData = canvas.toDataURL('image/jpeg', 0.95);
      const pdf = new jsPDF('p', 'mm', 'a4', true);
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = pdf.internal.pageSize.getHeight();
      const canvasWidth = canvas.width;
      const canvasHeight = canvas.height;
      const marginLeft = 10;
      const marginRight = 10;
      const availableWidth = pdfWidth - marginLeft - marginRight;
      const scaleFactor = availableWidth / canvasWidth;
      const imgWidth = canvasWidth * scaleFactor;
      const imgHeight = canvasHeight * scaleFactor;
      const pages = Math.ceil(imgHeight / pdfHeight);

      for (let i = 0; i < pages; i++) {
        if (i > 0) pdf.addPage();
        pdf.addImage(imgData, 'JPEG', marginLeft, -i * pdfHeight, imgWidth, imgHeight, undefined, 'FAST');
      }
      pdf.save('Dr.Shaharin_Banu_Profile.pdf');
    }).catch(error => {
      console.error('Error generating PDF:', error);
      alert('Failed to generate PDF. Please try again.');
      container.classList.remove('veenadoc-pdf-mode');
    });
  }, 100);
};

  return (
    <>
      <div className="veenadoc">
        {/* Hero Section */}
        <div className="veenadoc-hero-section">
          <div className="veenadoc-hero-background">
            <div className="veenadoc-wave-pattern">
              <svg viewBox="0 0 1200 320" className="veenadoc-wave-svg" preserveAspectRatio="none">
                <path d="M0,96L48,112C96,128,192,160,288,186.7C384,213,480,235,576,213.3C672,192,768,128,864,128C960,128,1056,192,1152,208C1248,224,1344,192,1392,176L1440,160L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z" fill="rgba(46, 125, 50, 0.1)"></path>
              </svg>
            </div>
            <div className="veenadoc-floating-shapes">
              <div className="veenadoc-shape veenadoc-shape-1"></div>
              <div className="veenadoc-shape veenadoc-shape-2"></div>
              <div className="veenadoc-shape veenadoc-shape-3"></div>
              <div className="veenadoc-shape veenadoc-shape-4"></div>
            </div>
          </div>

          <div className="veenadoc-container">
            <div className="veenadoc-hero-content">
              <div className="veenadoc-hero-left">
                <h1 className="veenadoc-hero-title">
                  <span className="veenadoc-title-highlight">Dr. Shaharin Banu</span>
                  <span className="veenadoc-title-credentials">(BHMS)</span>
                  <span className="veenadoc-title-location">Homoeopathic Consultant & Dietician</span>
                </h1>

                <div className="veenadoc-hero-description">
                  <p>
                    A dedicated Homoeopathic Consultant who brings a fresh and compassionate perspective to holistic healing. 
                    Known for her commitment to excellence and integrity, she provides patient-centered care that focuses on 
                    the individual needs of every person she treats.
                  </p>
                </div>

                <div className="veenadoc-hero-actions">
                  <button className="veenadoc-btn-primary-gradient" onClick={() => navigate('/bookconsultation')}>
                    <span className="veenadoc-btn-icon">📞</span>
                    <span>Book Consultation</span>
                    <div className="veenadoc-btn-shine"></div>
                  </button>
                </div>
              </div>

              <div className="veenadoc-hero-right">
                <div className="veenadoc-doctor-showcase">
                  <div className="veenadoc-doctor-frame">
                    <div className="veenadoc-frame-glow"></div>
                    <div className="veenadoc-image-container">
                      <img src={shaharinDoc} alt="Dr. Shaharin Banu – Homoeopathic Consultant & Dietician" className="veenadoc-doctor-image" title='Dr. Shaharin Banu – Homoeopathic Consultant & Dietician' />
                      <div className="veenadoc-image-overlay"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Article Content */}
        <div className="veenadoc-article-section">
          <div className="veenadoc-container">
            <div className="veenadoc-article-layout">
              <div className="veenadoc-article-main">
                {/* Introduction */}
                <div className="veenadoc-article-block">
                  <h2>About Dr. Shaharin Banu</h2>
                  <p>
                    Dr. Shaharin Banu completed her professional medical education at the prestigious Vinayaka Mission Homoeopathic 
                    Medical College and Hospital, where she developed a strong clinical foundation in classical homeopathy. 
                    Beyond her primary medical degree, she has pursued additional training as a Dietician.
                  </p>
                  <p>
                    This unique combination of homeopathic expertise and nutritional knowledge allows her to offer a truly 
                    comprehensive approach to wellness. She believes that health is a balance of internal medicine and 
                    proper lifestyle choices, making her a sought-after consultant for natural recovery.
                  </p>
                </div>

                {/* Clinical Journey */}
                <div className="veenadoc-article-block">
                  <h2>Clinical Journey & Education</h2>
                  <p>
                    Dr. Shaharin’s clinical journey began at the Vinayaka Mission Homoeopathic Medical College and Hospital, 
                    where she completed her intensive internship. During this period, she gained valuable hands-on experience 
                    in diagnosing and managing a wide variety of health conditions.
                  </p>
                  <p>
                    Her time at this reputed institution helped her refine her skills in patient interaction and clinical 
                    analysis, ensuring that every treatment plan she creates is backed by solid medical training and a 
                    deep understanding of homeopathic principles.
                  </p>
                </div>

                <div className="veenadoc-sidebar-card">
                  <h3>Quick Information</h3>
                  <div className="veenadoc-info-grid">
                    <div className="veenadoc-info-item">
                      <span className="veenadoc-info-label">Qualification:</span>
                      <span className="veenadoc-info-value">BHMS</span>
                    </div>
                    <div className="veenadoc-info-item">
                      <span className="veenadoc-info-label">Specialization:</span>
                      <span className="veenadoc-info-value">Homoeopathy & Dietetics</span>
                    </div>
                    <div className="veenadoc-info-item">
                      <span className="veenadoc-info-label">Training:</span>
                      <span className="veenadoc-info-value">Qualified Dietician</span>
                    </div>
                  </div>
                </div>

                {/* Integration of Dietetics */}
                <div className="veenadoc-article-block">
                  <h2>Integrating Homeopathy & Nutrition</h2>
                  <p>
                    As a Homoeopathic Consultant and Dietician, Dr. Shaharin Banu is particularly skilled at integrating 
                    dietary management with homeopathic remedies. She understands that nutrition plays a vital role in 
                    the body’s ability to heal itself.
                  </p>
                  <p>
                    Whether a patient is seeking help for chronic issues or general wellness, her dual expertise ensures 
                    that they receive guidance on both the right remedies and the right fuel for their bodies, leading 
                    to more effective and sustainable health outcomes.
                  </p>
                </div>

                {/* Patient Centered Care */}
                <div className="veenadoc-article-block">
                  <h2>Patient-Centered Care & Integrity</h2>
                  <p>
                    Dr. Shaharin is recognized for her professional integrity and her unwavering focus on patient well-being. 
                    She is known for her thoroughness and her ability to make patients feel heard and respected.
                  </p>
                  <p>
                    Her goal is to empower individuals to take charge of their health through safe, natural, and 
                    scientifically-grounded homeopathic care. This approach builds a strong bond of trust, which 
                    is essential for long-term healing.
                  </p>
                </div>

                {/* Conclusion */}
                <div className="veenadoc-article-block veenadoc-conclusion-block">
                  <h2>Choose Dr. Shaharin Banu for Holistic Healing</h2>
                  <p>
                    Choosing Dr. Shaharin Banu means selecting a practitioner who values excellence and treats every 
                    case with the utmost respect. Her dedication to homeopathy, combined with specialized knowledge 
                    in dietetics, makes her a reliable choice for a modern, holistic approach to healthcare.
                  </p>
                  <p className="veenadoc-mission-statement">
                    <strong>Her mission:</strong> To provide high-quality, compassionate care that leads to lasting 
                    health and renewed vitality for all her patients.
                  </p>
                </div>
              </div>

              {/* Sidebar */}
              <div className="veenadoc-article-sidebar">
                {/* Philosophy of Care */}
                <div className="veenadoc-article-block veenadoc-philosophy-block">
                  <div className="veenadoc-philosophy-quote">
                    <div className="veenadoc-quote-icon">💫</div>
                    <blockquote>
                      "Committed to delivering compassionate, patient-centered care with excellence and integrity."
                    </blockquote>
                    <p className="veenadoc-quote-attribution">— Dr. Shaharin Banu's Philosophy</p>
                  </div>
                  <p>
                    She believes in treating the person as a whole, not just the symptoms. By listening carefully 
                    to her patients and understanding their unique health journeys, she ensures that her care is 
                    both empathetic and effective.
                  </p>
                </div>

                {/* Locations */}
                <div className="veenadoc-sidebar-card">
                  <h3>Consultation Services</h3>
                  <div className="veenadoc-location-item">
                    <div className="veenadoc-location-icon">📍</div>
                    <div className="veenadoc-location-details">
                      <h4>Holistic Health Services</h4>
                      <p>Personalized Homeopathic Care</p>
                    </div>
                  </div>
                  <div className="veenadoc-location-item">
                    <div className="veenadoc-location-icon">🥗</div>
                    <div className="veenadoc-location-details">
                      <h4>Dietary Consultation</h4>
                      <p>Nutritional Guidance for Wellness</p>
                    </div>
                  </div>
                </div>

                {/* Contact CTA */}
                <div className="veenadoc-sidebar-card veenadoc-cta-card">
                  <h3>Start Your Healing Journey</h3>
                  <p>Experience compassionate healthcare with Dr. Shaharin's personalized approach.</p>
                 <button
                  className="veenadoc-sidebar-btn-primary"
                  onClick={() => window.location.href = 'tel:+919964688333'}
                >
                  <span>📞</span>
                  <span>Schedule Appointment</span>
                </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <AutoScrollImageRow/>

       <div className="bangloregfcblog-download-section">
            <button className="bangloregfcblog-download-button" onClick={handleDownloadPdf}>
              Download This Doctor profile as PDF
            </button>
          </div>
    </>
  )
}

export default ShaharinDoc
